import * as Yup from 'yup';

export const ContactFormSchema = Yup.object().shape({
  name: Yup.string().required('Le nom est requis.').min(2, 'Le nom doit avoir au moins 2 caractères.'),
  email: Yup.string().required("L'email est requis.").email("L'email n'est pas valide."),
  message: Yup.string().required('Le message est requis.').min(10, 'Le message doit avoir au moins 10 caractères.'),
});
